// Renders a person (the owner/actor of a key or event): a gradient avatar with
// initials + their email, marking "you" when it matches the signed-in user.
// The email is denormalized on the row; identity is canonical via ownerUserId.

function initials(email: string): string {
  const local = email.split("@")[0] ?? email;
  const parts = local.split(/[.\-_]/).filter(Boolean);
  const chars = (parts.length >= 2 ? [parts[0], parts[1]] : [local]).map(
    (s) => s?.[0]?.toUpperCase() ?? "",
  );
  return chars.join("").slice(0, 2) || "?";
}

export function OwnerCell({
  email,
  youEmail,
}: {
  email: string | null;
  youEmail?: string;
}) {
  if (!email) return <span className="text-ink-subtle">—</span>;
  const you = youEmail && youEmail.toLowerCase() === email.toLowerCase();
  return (
    <div className="flex items-center gap-2.5">
      <span className="flex h-[26px] w-[26px] shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-accent to-[#5B4BE0] text-[11px] font-bold text-white">
        {initials(email)}
      </span>
      <span className="min-w-0">
        <span className="block truncate text-[13px] text-ink">{email}</span>
        {you && (
          <span className="font-mono text-[10px] uppercase tracking-wide text-accent">
            You
          </span>
        )}
      </span>
    </div>
  );
}
